import * as _ from 'lodash';

import { IAction, ActionType } from "../../classes/actiontype";

export interface IApiState {
    isWaiting: boolean;
    response: string;
    error: string;
}

export const defaultApiState: IApiState = {
    isWaiting: false,
    response: "",
    error: ""
};

export default function apiReducer(state: IApiState = defaultApiState, action: IAction) {
    switch (action.type) {
        case ActionType.REQUEST_FAVORITE: {
            return _.assign({}, state, { isWaiting: true, response: "", error: "" });
        }

        case ActionType.RECEIVE_FAVORITE: {
            return _.assign({}, state, { isWaiting: false, response: action.value });
        }

        case ActionType.ERROR_FAVORITE: {
            return _.assign({}, state, { isWaiting: false, error: action.value });
        }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/favorites/redux/reducers/api-reducer.ts